export default __webpack_public_path__ + "static/media/clock.3ec49901.svg";